import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import AutomationsView from './automations-view'
import WebhooksView from './webhooks-view'
import ApiKeysView from './api-keys-view'
import useStyles from './styles'

const VIEWS = [
  { value: 'automations', label: 'Automations', Content: AutomationsView },
  { value: 'webhooks', label: 'Webhooks', Content: WebhooksView },
  { value: 'api-keys', label: 'API keys', Content: ApiKeysView },
]

/** Older standalone pages that now open a view of this tab. */
const LEGACY_VIEWS = {
  '/workspace/webhooks': 'webhooks',
  '/workspace/api-keys': 'api-keys',
}

/**
 * Workspace > Integrations: Zapier/Make automations, workspace webhooks and
 * API keys. The view lives in `?view=` so the old /workspace/webhooks and
 * /workspace/api-keys links land on it.
 */
const IntegrationsTab = () => {
  const classes = useStyles()
  const history = useHistory()
  const location = useLocation()

  const requested = new URLSearchParams(location.search).get('view')
  const legacy = LEGACY_VIEWS[location.pathname.replace(/\/+$/, '')]
  const view =
    VIEWS.find(item => item.value === requested) ||
    VIEWS.find(item => item.value === legacy) ||
    VIEWS[0]

  const select = value =>
    history.replace(`/workspace/integrations?view=${value}`)

  return (
    <div className={classes.root}>
      <div className={classes.segmented}>
        {VIEWS.map(item => (
          <button
            key={item.value}
            type="button"
            className={`${classes.segment} ${
              item === view ? classes.segmentActive : ''
            }`}
            onClick={() => select(item.value)}
          >
            {item.label}
          </button>
        ))}
      </div>
      <view.Content />
    </div>
  )
}

export default IntegrationsTab
